import { useQuery } from "@apollo/client";
import { ChangeEvent } from "react";
import { Col, Form, FormGroup, Input, Label } from "reactstrap";
import { GET_VALUE_LIST_TYPES } from "../../../graphql/valuelist-gql";
import { IValueListTypesResponse } from "../../../types/valuelist";
import SpinnerOverlay from "../../common/spinner/spinner";
import './style.scss';
import useValueListApi from "./useValueListApi";

const ValueSearchForm = () => {
  const { data } = useQuery<IValueListTypesResponse>(GET_VALUE_LIST_TYPES);

  const { loadValueList, busy } = useValueListApi();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) =>
    loadValueList(event.target.value);

  return (
    <Form id="value_list_form">
      <FormGroup row>
        <Label for="value_list_type" md={4} lg={2}>
          Value Group:
        </Label>
        <Col md={6} lg={3}>
          <Input type="select" id="value_list_type"
            onChange={handleChange} defaultValue="" disabled={busy}>
            <option value="" disabled={true}>Select a value group</option>
            {data?.valueListTypes.map((type) =>
              <option key={type} value={type}>{type}</option>
            )}
          </Input>
        </Col>
      </FormGroup>

      {busy && <SpinnerOverlay />}
    </Form>
  );
};

export default ValueSearchForm;
